const apiUrls = require('../../constants/apiUrls');
const accountMemos = {
    key: 'accountMemos',
    method: 'GET',
    getApiUrl: (request) => {
        return `${apiUrls.ACCOUNT_MEMO_DETAIL_URL}?billingSystem=${request.billingSystem}&accountNumber=${request.accountNumber}`;
    },
    dependencies: [
        {
            key: 'orderDetails',
            requestProps: [
                {
                    path: [
                        'details', 'accountNumber'
                    ],
                    propName: 'accountNumber'
                }
            ]
        }, {
            key: 'schedulingSystemDetails',
            requestProps: [
                {
                    path: [
                        'details', 'billingSystem'
                    ],
                    propName: 'billingSystem'
                }
            ]
        }
    ]
};

export default accountMemos;


// WEBPACK FOOTER //
// ./src/store/order-details-config/accountMemos.js